export const QUERY_KEY_COUPONS = 'Coupons'
